import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import styled from 'styled-components';
// components
import PlanButton from 'components/molecules/event/PlanButton';
// slices
import { getEventBanner } from 'slices/event.thunk';
// hooks
import { useDispatch, useSelector } from 'hooks/common/useStore';
// utils
import deviceChecker from 'lib/utils/deviceChecker';
// styles
import { mediaQuery } from 'cds/styles';

/** 기획전 버튼 리스트 */
const PlanList = () => {
  const router = useRouter();

  const dispatch = useDispatch();

  const [bannerList] = useSelector(state => [state.event.banner]);
  const [isApp, setIsApp] = useState(true);

  useEffect(() => {
    const device = deviceChecker();
    if (device.app()) {
      return setIsApp(true);
    }
    setIsApp(false);
  }, []);

  useEffect(() => {
    if (!router.isReady) {
      return;
    }

    if (bannerList.length) {
      return;
    }

    dispatch(getEventBanner());
  }, [dispatch, bannerList.length, router.isReady, isApp, bannerList]);

  const list = bannerList.filter(v => (/notice/i.test(v.link) || /open/i.test(v.link) ? false : v));

  const PlanButtonList = list.map(plan => {
    return (
      <PlanButton
        key={plan.link}
        href={plan.link.replace(
          /https:\/\/www.classu.co.kr\/class\/event/gi,
          `${process.env.NEXT_PUBLIC_DEFAULT_HOST}/event/plan`,
        )}
        imageURL={plan.image}
        bgColor={plan.backcolor}
      />
    );
  });

  return <Layout>{PlanButtonList}</Layout>;
};

const Layout = styled.ul`
  padding: 24px 0 32px 0;

  ${mediaQuery.medium} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
`;

export default PlanList;
